import React from 'react';
import FormContainer from '../../forms/FormContainer/FormContainer';
import ButtonContainer from '../../forms/ButtonContainer/ButtonContainer';

export default function Success({ profileId }) {
    return (
        <FormContainer>
            <div>
                <h2>Profile created!</h2>
                <p>Thank you, your profile is now active and you can start uploading products.</p>
                <ButtonContainer>
                    <a href="/marketplace/upload/" className="meatex-button">Upload product</a>
                    {profileId && (<a href={`/marketplace/profile/${profileId}`} className="meatex-button meatex-button--orange">View profile</a>)}
                </ButtonContainer>
            </div>
        </FormContainer>
    )
}
